import React, {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux'
import {useHistory, useLocation, useParams} from 'react-router-dom'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import {permissions} from '../../../../../_constants/permissions'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {hasPermission} from '../../../../../_helper/hasPermission'
import {Button} from '@mui/material'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
  import { OCCUPATIONAL_THERAPIST_DATA_MAPPING,OCCUPATIONAL_THERAPIST_LISTING_COLOUMS,
  OCCUPATIONAL_THERAPIST_NOTE_ENTRY_DATA_MAPPING,
  OCCUPATIONAL_THERAPIST_NOTE_ENTRY_LISTING_COLOUMS,
  OCCUPATIONAL_THERAPIST_NOTE_ENTRY_SORTING_DATA,
  OCCUPATIONAL_THERAPIST_SORTING_DATA, } from '../../../Notes/Occupational_therapy/list/OCCUPATIONAL_THERAPIST_TABLE_CONSTANTS'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import axios from 'axios'
import {RootState} from '../../../../../setup'
import {MoonLoader} from 'react-spinners'
import dayjs from 'dayjs'
import IsFormCompletedModal,{validateFormCompletion} from '../../../Notes/Nurses_Notes/isFormCompleted'
const selectAuth = (state: RootState) => state.auth
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedOccupationalTherapyNotes = () => {
  const [filteredData, setFilteredData] = useState<any[]>([])
  const [deletedID, setDeletedID] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [isFetchingData, setIsFetchingData] = useState(true)
  const [loadingStates, setLoadingStates] = useState({})
  const dispatch = useDispatch()
  const auth = useSelector(selectAuth)
  const userPermissions = auth.user.roleId
  const companyLogo = auth?.user?.companyLogo
  const [logoUrl, setLogoUrl] = useState('')
  const timeZone = useSelector(selectTimeZone)
  const [showWarningModal, setShowWarningModal] = useState(false)
  const [pendingDownloadRow, setPendingDownloadRow] = useState(null)
  const {id}: {id: string} = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const noteType = queryParams.get('noteType')
  const history = useHistory()
  const [isPDFDownloaded, setIsPDFDownloaded] = useState(false);
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  useEffect(() => {
    const fetchData = async (page: number, pageSize: number, sortBy: string, sortDir: string) => {
      setIsFetchingData(true)
      const responseForNote = await axios.get(`/otProgressNotesEntry/getByClient/${id}?noteType=${noteType}`, {
        params: {
          page: page,
          pageSize: pageSize,
          sortBy: sortBy,
          sortDir: sortDir,
          searchTerm: queryData.searchTerm,
          isDeleted: true,
        },
      })
      const {data: noteData, currentPage, totalCounts} = responseForNote?.data
      const updatedNoteData = noteData.map((item) => ({
        ...item,
        startDate: item?.startDate
          ? dayjs.utc(item.startDate).tz(timeZone).format('MM-DD-YYYY')
          : 'No details provided',
        endDate: item?.endDate
          ? dayjs.utc(item.endDate).tz(timeZone).format('MM-DD-YYYY')
          : 'No details provided',
      }))
      setFilteredData(updatedNoteData)
      setQueryData((prevState) => {
        return {
          ...prevState,
          currentPage,
          totalCounts,
        }
      })
      setIsFetchingData(false)
    }
    fetchData(queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir)
  }, [
    queryData.pageNumber,
    queryData.pageSize,
    queryData.sortBy,
    queryData.sortDir,
    queryData.searchTerm,
    deletedID,
    isPDFDownloaded
  ])

  const handleUpdate = (row: any) => {
    history.push(`/deleted-notes/occupational-therapy-notes/entry/${row._id}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        {isFetchingData ? (
          <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
            <MoonLoader color='#9db2fc' size={60} loading={isFetchingData} />
          </div>
        ) : (
          <div>
            <TableTitle title='Delete OT Notes' />
            <TableWrapper
              searchField={
                <TableSearchBar
                  label='Search'
                  variant='outlined'
                  size='small'
                  value={searchTerm}
                  setQueryData={setQueryData}
                  setSearchTerm={setSearchTerm}
                  margin='normal'
                  inputAdornmentPosition='start'
                />
              }
              tableButtons={
                <div className='d-flex justify-content-end gap-2'>
                  <Button
                    variant='outlined'
                    color='primary'
                    onClick={() => history.push(`/notes/occupational-therapy-notes/list`)}
                  >
                    Back
                  </Button>
                </div>
              }
              dynamicTable={
                <DynamicTable
                  columns={OCCUPATIONAL_THERAPIST_NOTE_ENTRY_LISTING_COLOUMS}
                  data={filteredData}
                  canUpdate={true}
                  onUpdate={handleUpdate}
                  columnDataMapping={OCCUPATIONAL_THERAPIST_NOTE_ENTRY_DATA_MAPPING}
                  sortingColumns={OCCUPATIONAL_THERAPIST_NOTE_ENTRY_SORTING_DATA}
                  clickableRow={false}
                  loadingStates={loadingStates}
                  setQueryData={setQueryData}
                  queryData={queryData}
                />
              }
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DeletedOccupationalTherapyNotes
